import { TooltipWrapper } from 'components/TooltipWrapper';
import type { BimContractOtherStatusEnum, WorkOrderPriceStatusEnum, ContractOtherStatusEnum } from 'gql/graphql';
import { OtherCostCalculationTypeEnum } from 'gql/graphql';
import { CodeCell } from 'pages/Project/Common/CodeCell';
import type { AnyObject } from 'types/AnyObject';
import { Badge } from 'uikit';
import { formatNumberToRu } from 'utils';

import type { RowClassRules, ValueFormatterParams } from 'ag-grid-community';

export const statusRenderer = <
    T extends {
        status: WorkOrderPriceStatusEnum | BimContractOtherStatusEnum | ContractOtherStatusEnum;
        isActKC2Price?: boolean;
        isAddedRow?: boolean;
    },
>({
    data,
}: {
    data: T;
}) => {
    if (!data?.status && !data?.isActKC2Price) {
        return '';
    }

    if (data?.isActKC2Price && data?.status) {
        return (
            <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                <TooltipWrapper message="Добавлено из Акта КС-2" size="m" isInteractive={false}>
                    <Badge label="Д" status="success" size="s" />
                </TooltipWrapper>
                <CodeCell status={data?.status} />
            </div>
        );
    }

    if (data?.isAddedRow) {
        return (
            <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                <TooltipWrapper message="Добавлено из Изм. к НЗ" size="m" isInteractive={false}>
                    <Badge label="Д" status="success" size="s" />
                </TooltipWrapper>
                <CodeCell status={data?.status} />
            </div>
        );
    }

    return (data?.status && <CodeCell status={data?.status} />) || undefined;
};

export const percentCellFormatter = <T extends { calculatingType?: OtherCostCalculationTypeEnum | null }>(
    params: ValueFormatterParams<T>,
    decimalPlaces = 3,
) => {
    const { data, value } = params;

    if (data?.calculatingType === OtherCostCalculationTypeEnum.Percent) {
        return `${formatNumberToRu(value, decimalPlaces)} %`;
    }

    return value;
};

export const bimNumberFormatter =
    (decimal: number) =>
    ({ value }: { value: number }) =>
        formatNumberToRu(value, decimal);

export const getRowClass: RowClassRules = {
    groupTitleClass: ({ data }: { data: AnyObject }) => data?.isGroupTitle,
    bottomPinnedRowClass: ({ node }) => node.rowPinned === 'bottom',
    transparentRow: ({ data }: { data: { isExcludedRow: boolean } }) => Boolean(data?.isExcludedRow),
};
